import { jsx as i } from "react/jsx-runtime";
import { forwardRef as p } from "react";
import n from "styled-components";
import u from "../../icons/search.js";
import a from "../TextField/TextField.js";
const r = n(u).withConfig({
  displayName: "StyledSearchIcon"
})([
  "height:16px;width:16px;margin-left:12px;flex-shrink:0;"
]), m = n(a).withConfig({
  displayName: "StyledTextField"
})([
  "&&&.textFieldRoot .outlinedInputRoot input.outlinedInput{padding-left:8px;}&& .outlinedInputRoot:hover:not(.outlinedInputDisabled),&& .outlinedInputRoot.inputFocused:not(.outlinedInputDisabled){padding-right:",
  ";}&& .outlinedInputRoot.inputFocused:not(.outlinedInputDisabled) input.outlinedInput,&& .outlinedInputRoot:hover:not(.outlinedInputDisabled) input.outlinedInput{padding-right:",
  ";margin-right:",
  ";}"
], (t) => !t.disableClear && "28px", (t) => !t.disableClear && "40px", (t) => !t.disableClear && "-56px"), h = /* @__PURE__ */ p(({ InputProps: t, disableClear: o = !1, slotProps: e, ...d }, l) => /* @__PURE__ */ i(m, {
  ref: l,
  ...d,
  slotProps: {
    ...e,
    input: {
      ...t,
      ...e == null ? void 0 : e.input,
      startAdornment: /* @__PURE__ */ i(r, {})
    }
  },
  disableClear: o,
  type: "text"
}));
h.displayName = "Search";
export {
  h as default
};
